var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFastRewind2 = function SvgFastRewind2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    stroke: "#828282",
    d: "m12 3.367 5.035 7.133H6.965z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#828282",
    d: "M6.965 13.5h10.07L12 20.633z"
  })));
};
export default SvgFastRewind2;